import { Nullable } from "@gemlightbox/core-kit";

export const getWhatsappLink = (phone: Nullable<string>): string => {
  if (!phone) return "";
  const url = new URL(`https://wa.me/${phone}`);
  url.searchParams.append("text", "Hi! I'd like to learn more about your products.");
  return url.toString();
};
